module.exports = "https://web-assets.ifttt.com/packs/media/stencils/short-message-5cd93e50.svg";